const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      ServicesTemplate {
        titleTestimonials
        testimonials {
          description
          author
        }
      }
    }
  }
`;
export default fetchData;
